import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "TRAJECTORIES_SIMULATION_LMIC",
  title: defineMessage({
    id: "fig.learning.trajectories.TRAJECTORIES_SIMULATION_LMIC.title",
    defaultMessage: `Simulations of the relative impact of achieving universal schooling and higher learning per grade in low- and lower-middle-income countries`,
  }),
  caption: defineMessage({
    id: "fig.learning.trajectories.TRAJECTORIES_SIMULATION_LMIC.caption",
    defaultMessage: `Descriptive and simulated learning trajectories for 10 low- and lower-middle-income countries showing the percentage of children (aged 7–14 years) who have mastered foundational skills, typically at the Grade 2–3 level. This is below the minimum proficiency level defined by SDG global indicator 4.1.1. Trajectories by age include all children (whether they were in school at the time of the survey, had dropped out or had never attended school).`,
  }),
  source: defineMessage({
    id: "fig.learning.trajectories.TRAJECTORIES_SIMULATION_LMIC.source",
    defaultMessage: `UNICEF MICS6 data based on simulation methodology and analysis by RISE.`,
  }),
};
